import React from "react";
import { locale } from "../../../translate/sweden";
import "./Terms.scss";

const Terms = (props) => {
  return (
    <div className="Terms">
      <p>{props.toc}</p>
      <div className="termsBottom" onClick={props.onSave}>
        <button>
          {locale.iAccept} {locale.terms}
        </button>
      </div>
    </div>
  );
};

export default Terms;
